import React, { useState, useEffect } from 'react';
import styles from '../styles/WorksCarousel.module.css';
import { fetchData } from '../utils/apiClient';

const WorksCarousel = () => {
    const defaultImages = [
        '/works/REC.jpg',
        '/works/mercari.jpg',
        '/images/suntory2.jpg',
        '/works/REC.jpg',
        '/works/mercari.jpg',
        '/images/suntory2.jpg',
        '/works/REC.jpg',
        '/works/mercari.jpg',
        '/images/suntory2.jpg',
        '/works/REC.jpg',
        '/works/mercari.jpg',
        '/images/suntory2.jpg',
    ];

    const [images, setImages] = useState(defaultImages);
    const [isLoading, setIsLoading] = useState(true); // 追加: ロード状態

    useEffect(() => {
        const fetchSlideshowImages = async () => {
            try {
                const data = await fetchData('/api/getSlideshow.php');
                if (data.status === 'success' && data.data.length > 0) {
                    const fetchedUrls = data.data.map(item => item.image_url);
                    let displayUrls = [...fetchedUrls];
                    while (displayUrls.length < 12) {
                        displayUrls = [...displayUrls, ...fetchedUrls];
                    }
                    setImages(displayUrls);
                }
            } catch (err) {
                console.warn("スライドショーAPI取得失敗。デフォルト画像を使用します。", err);
            } finally {
                setIsLoading(false); // 追加: fetch完了時にローディング解除
            }
        };

        fetchSlideshowImages();
    }, []);

    // スケルトン用のダミー配列
    const skeletonArray = new Array(12).fill(null);

    return (
        <div className={styles.carouselContainer}>
            {/* 1セット目のトラック */}
            <div className={styles.carouselTrack}>
                {isLoading
                    ? skeletonArray.map((_, index) => (
                        <div key={`skel1-${index}`} className={`${styles.slide} ${styles.skeleton}`}></div>
                    ))
                    : images.map((src, index) => (
                        <div key={`set1-${index}`} className={styles.slide}>
                            <img src={src} alt={`Work ${index}`} className={styles.image} loading="lazy" decoding="async" />
                        </div>
                    ))}
            </div>
            {/* 2セット目のトラック (スムーズな無限ループ接続用) */}
            <div className={styles.carouselTrack} aria-hidden="true">
                {isLoading
                    ? skeletonArray.map((_, index) => (
                        <div key={`skel2-${index}`} className={`${styles.slide} ${styles.skeleton}`}></div>
                    ))
                    : images.map((src, index) => (
                        <div key={`set2-${index}`} className={styles.slide}>
                            <img src={src} alt={`Work clone ${index}`} className={styles.image} loading="lazy" decoding="async" />
                        </div>
                    ))}
            </div>
        </div>
    );
};

export default WorksCarousel;
